import { apiSlice } from '@/api'

export const billingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBilling: builder.query({
      query: (args) => {
        const { buildingId, page, size, plate_number, from_date, to_date } =
          args
        return {
          url: `api/v2/billing/building/${buildingId}`,
          method: 'GET',
          params: { plate_number, page, size, from_date, to_date }
        }
      },
      providesTags: (result, _error, _arg) =>
        result?.data && Array.isArray(result.data)
          ? [
              ...result.data.map(({ id }) => ({ type: 'Billing', id })),
              'Billing'
            ]
          : ['Billing']
    }),
    postWriteOff: builder.mutation({
      query: (body) => ({
        url: 'api/v2/billing/write_off',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Billing']
    }),
    editPlateNumber: builder.mutation({
      query: ({ id, plate_number }) => ({
        url: `/api/v1/billing/${id}/plate_number`,
        method: 'PATCH',
        body: { plate_number }
      })
    }),
    getPlateHistory: builder.query({
      query: (billingId) => `/api/v1/billing/${billingId}/plate_number_history`
    }),
    getOccupancy: builder.query({
      // ← внутри endpoints, через запятую
      query: (buildingId) => ({
        url: `api/v2/billing/building/${buildingId}/occupancy`,
        method: 'GET'
      }),
      providesTags: ['Billing']
    })
  })
})

export const {
  useGetBillingQuery,
  usePostWriteOffMutation,
  useGetOccupancyQuery
} = billingApi
